import { UseFormReturn } from 'react-hook-form'
import { BannerFormValues } from '../../useBannerForm'
import { BannerType } from '@/app/entities/Banner'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/view/components/ui/form'
import { ImageUpload } from '@/view/components/FileUpload'
import { getSizeLabel } from '../../utils'
import { Scan } from 'lucide-react'
import { cn } from '@/app/utils/cn'

const ImageDescription = ({ description }: { description: string }) => {
  return (
    <div className="flex items-center gap-4 text-muted-foreground">
      <Scan size={20} />
      <span className="text-sm">{description}</span>
    </div>
  )
}

interface FormFieldImageProps {
  form: UseFormReturn<BannerFormValues>
  imageUrl: string | null
  height: number
  width: number
  type: BannerType
}
export const FormFieldImage = ({
  form,
  type,
  height,
  imageUrl,
  width,
}: FormFieldImageProps) => (
  <FormField
    control={form.control}
    name="file"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Imagem</FormLabel>
        <FormControl>
          <ImageUpload
            description={<ImageDescription description={getSizeLabel(type)} />}
            defaultImage={imageUrl}
            className={cn('overflow-hidden rounded-lg border p-4')}
            onInputChange={field.onChange}
            height={height}
            width={width}
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
)
